import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f5befa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "modal-card",
  tabindex: "0"
}
const _hoisted_8 = { class: "modal-card-head" }
const _hoisted_9 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_10 = { class: "icon has-text-white" }
const _hoisted_11 = { class: "modal-card-title is-title-shrink" }
const _hoisted_12 = { class: "modal-card-body" }
const _hoisted_13 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecipientSelector = _resolveComponent("RecipientSelector")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_RecipientInfo = _resolveComponent("RecipientInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Recipient Selector")) + " - 1/2 ", 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
            })
          ]),
          _createVNode(_component_RecipientSelector, {
            showAll: true,
            purpose: "inspect",
            onClickRecipient: _ctx.handleClickRecipient,
            currency: _ctx.currency
          }, null, 8, ["onClickRecipient", "currency"]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("header", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("a", {
                class: "mr-3 is-flex",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$modal.back()))
              }, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_fa_icon, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$gettext("Recipient Info")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$modal.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_12, [
            _createVNode(_component_RecipientInfo, {
              ref: "recipientInfo",
              recipient: _ctx.recipient,
              currency: _ctx.currency,
              onAccountFormChange: _ctx.handleAccountFormChange,
              onRefreshCurrency: _ctx.handleRefreshCurrency
            }, null, 8, ["recipient", "currency", "onAccountFormChange", "onRefreshCurrency"])
          ]),
          _createElementVNode("footer", _hoisted_13, [
            (_ctx.canChangeStatus)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "button is-danger is-rounded",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleArchiveAccount && _ctx.handleArchiveAccount(...args)))
                }, _toDisplayString(_ctx.$gettext("Archive")), 1))
              : _createCommentVNode("", true),
            (_ctx.canCreditAnyAccount)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "button is-pay is-rounded mr-2",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCreditMoney && _ctx.handleCreditMoney(...args))),
                  disabled: !_ctx.isActiveAccount
                }, _toDisplayString(_ctx.$gettext("Credit money")), 9, _hoisted_14))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "button is-pay is-rounded",
              disabled: !_ctx.isAccountFormChanged || !_ctx.isFormValid,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSaveAccountChanges && _ctx.handleSaveAccountChanges(...args)))
            }, _toDisplayString(_ctx.$gettext("Save changes")), 9, _hoisted_15)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}